<div class="d-flex available-product align-items-center">
  <fa-icon [icon]="circleIcon" size="2x" class="set-unavailable-button" (click)="setProductUnavailable()"></fa-icon>
  <span class="product-name p-2">{{ product.name }}</span>
</div>
